module.exports = __webpack_public_path__ + "static/media/constructionImage.f03e98e5.jpg";